export default {
  create: {
    title: 'Add',
    subtitle: 'User',
  },
  edit: {
    title: 'Edit',
    subtitle: 'User',
    button: {
      add: 'New user',
    },
  },
  list: {
    title: 'Users',
    subtitle: 'List',
    add: 'New user',
  },
  table: {
    title: 'Active users',
    searchPlaceholder: 'Search...',
    noContent: 'No users have been registered yet.',
    columns: {
      name: 'Name',
      email: 'Email',
      role: 'Role',
      options: 'Options',
    },
    actions: {
      delete: 'Delete',
    },
  },
  delete: {
    title: 'Confirm user deletion',
    message: 'Are you sure you want to delete this user?',
  },
  account: {
    title: 'Profile',

    form: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },

      email: {
        label: 'Email',
        placeholder: 'Email',
        invalid: 'Email is required',
      },

      userType: {
        label: 'User type',
      },

      role: {
        label: 'Role',
      },

      oldPassword: {
        label: 'Current password',
      },

      password: {
        label: 'Password',
        invalid: 'Passwords do not match',
      },

      passwordConfirmation: {
        label: 'Confirm password',
        invalid: 'Passwords do not match',
      },

      sendPassword: {
        label: 'Set password by email',
        options: {
          yes: 'Yes',
        },
      },

      submit: 'Save',
    },

    roles: {
      administrator: 'Administrator',
      none: 'None',
    },
  },
  profile: {
    title: 'User profile',
    subtitle: 'Overview',
  },
  alert: {
    deleted: 'User deleted successfully',
  },
};
